import { render, staticRenderFns } from "./ContinueScreen.vue?vue&type=template&id=22e5810a&"
import script from "./ContinueScreen.vue?vue&type=script&lang=js&"
export * from "./ContinueScreen.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports